var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"id":"default-footer","color":"transparent","absolute":"","app":"","inset":""}},[_c('links')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }